import React, { useEffect } from "react";
import { AnnouncementCard } from "../announcement-card/announcement-card";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useStyles } from "./styles";
import useAnnouncementsData from "./useAnnouncementsData";
import { toast } from "react-toastify";
import classNames from "classnames";
import {getCurrentLang, Translate} from "../../locales/locales-utils";

export const AnnouncementsContainer = () => {
  const classes = useStyles();
  const language = getCurrentLang();

  const { isFetching, data, isError } = useAnnouncementsData();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      partialVisibilityGutter: 40
    },
    tablet: {
      breakpoint: { max: 1200, min: 600 },
      items: 2,
      partialVisibilityGutter: 30
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      partialVisibilityGutter: 30
    },
  };

  useEffect(() => {
    if (isError) {
      toast.error(Translate("Index.Announcements.LoadError"));
    }
  }, [isError]);

  const ButtonGroup = ({
    next,
    previous,
    carouselState,
  }: {
    next?: any;
    previous?: any;
    carouselState?: any;
  }) => {
    const { currentSlide, totalItems, slidesToShow } = carouselState;

    return (
      <div className="carousel-button-group">
        <div
          className={
            "carousel-button-item previous " +
            (currentSlide === 0 ? "disabled" : "")
          }
          onClick={() => previous()}
        >
          Previous
        </div>
        <div
          className={
            "carousel-button-item next " +
            (currentSlide === totalItems - slidesToShow ? "disabled" : "")
          }
          onClick={() => {
            next();
          }}
        >
          Next
        </div>
      </div>
    );
  };

  const settings = {
    additionalTransfrom: 0,
    centerMode: false,
    swipeable: true,
    draggable: true,
    showDots: true,
    arrows: false,
    responsive: responsive,
    infinite: false,
    autoPlay: false,
    autoPlaySpeed: 2000,
    showThumbs: false,
    slidesToSlide: 1,
    renderButtonGroupOutside: true,
    customButtonGroup: <ButtonGroup />,
  };

  const StaticCards = () => {
    return (
      <div className={classes.staticCards}>
        <div className={classNames(classes.staticCard, classes.soonCard, {[classes.soonCardEn]: language === 'en'})}></div>
        <div className={classNames(classes.staticCard, classes.soonGiftCard, {[classes.soonGiftCardEn]: language === 'en'})}></div>
        <div className={classNames(classes.staticCard, classes.soonCard, {[classes.soonCardEn]: language === 'en'})}></div>
      </div>
    );
  };

  const SkeletonCard = () => (
    <div className={classNames(classes.staticCard, classes.skeletonCard)}>
      <div className={classNames(classes.skeletonElement, classes.skeletonCardMedia)} />
      <div className={classes.skeletonCardInfo}>
        <div className={classNames(classes.skeletonElement, classes.skeletonElementMd, classes.skeletonElementShort, classes.skeletonCardInfoDate)} />
        <div className={classNames(classes.skeletonElement, classes.skeletonElementXl, classes.skeletonCardInfoTheme)} />
        <div className={classNames(classes.skeletonElement, classes.skeletonElementSm, classes.skeletonCardInfoDescription)} />
        <div className={classNames(classes.skeletonElement, classes.skeletonElementSm, classes.skeletonCardInfoDescription)} />
        <div className={classNames(classes.skeletonElement, classes.skeletonElementSm, classes.skeletonElementShort, classes.skeletonCardInfoPrize)} />
        <div className={classNames(classes.skeletonElement, classes.skeletonElementXl, classes.skeletonCardInfoCode)} />
        <div className={classNames(classes.skeletonElement, classes.skeletonElementXl, classes.skeletonCardInfoButton)} />
      </div>
    </div>
  );

  const SkeletonCards = () => {
    return (
      <div className={classes.staticCards}>
        <SkeletonCard/>
        <SkeletonCard/>
        <SkeletonCard/>
      </div>
    );
  };

  const DynamicCards = () => {
    return (
      <Carousel {...settings}>
        <div className={classNames(classes.staticCard, classes.soonCard)}></div>
        {data.map((el, idx) => (
          <div key={idx}>
            <AnnouncementCard model={el} />
          </div>
        ))}
      </Carousel>
    );
  };

  return (
    <section
      className={`${classes.carouselMainContainer} announcements-container`}
    >
      <div className={`h1 ${classes.carouselMainTitle}`}>
        {Translate("Index.Announcements.Title")}
      </div>
      <div className={classes.carouselMainWrapper}>
        {isFetching && <SkeletonCards />}
        {!isFetching && data.length > 0 && <DynamicCards />}
        {!isFetching && data.length === 0 && <StaticCards />}
      </div>
    </section>
  );
};